const HomeActionTypes = {
    CHECK_STATUS: 'CHECK_STATUS',
    RELOAD_DATA: 'RELOAD_DATA'
}

export default HomeActionTypes;